import axios from "axios";
import qs from "qs";
import {
  ADD_NOTIFICATION,
  CHANGE_ALIAS,
  CHANGE_CUSTOMER,
  CHANGE_EMAIL,
  CHANGE_LANG,
  DONE,
  GET_CUSTOMERS_FAILURE,
  GET_CUSTOMERS_PROCESSING,
  GET_CUSTOMERS_SUCCESS,
  REMOVE_NOTIFICATION,
} from "../Constants";
import config from "../config";
import { Message } from "../locale/Message";

const BASE_URL = `${config.accountsUrl}/api`;

export const logout = (idToken) => {
  document.location = `
    ${config.keycloak.url}/realms/${config.keycloak.realm}/protocol/openid-connect/logout?id_token_hint=${idToken}&post_logout_redirect_uri=${encodeURI(document.location)}
  `;
};

export const changeLangAction = (lang) => (dispatch) =>
  dispatch({
    type: CHANGE_LANG,
    lang,
  });

export const getUserInfoAction = () => (dispatch, getState) => {
  if (getState().userInfo.status !== DONE) {
    dispatch({
      type: GET_CUSTOMERS_PROCESSING,
    });
    axios
      .get(`${BASE_URL}/users`, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Bearer ${getState().token}`,
        },
      })
      .then(({ data }) =>
        dispatch({
          type: GET_CUSTOMERS_SUCCESS,
          data: data,
        }),
      )
      .catch((error) =>
        dispatch({
          type: GET_CUSTOMERS_FAILURE,
          message: (error.response && error.response.message) || "server_error",
        }),
      );
  }
};

export const addNotificationAction = (message) => (dispatch) =>
  dispatch({
    type: ADD_NOTIFICATION,
    message: message,
  });

export const removeNotificationAction = (id) => (dispatch) =>
  dispatch({
    type: REMOVE_NOTIFICATION,
    id: id,
  });

export const changeCustomerAction = (customer) => (dispatch) =>
  dispatch({
    type: CHANGE_CUSTOMER,
    customer,
  });

export const changeAliasAction =
  ({ bin, customerAlias, onSuccess, onFailure }) =>
  (dispatch, getState) => {
    const { lang, token } = getState();
    axios
      .put(
        `${BASE_URL}/customers/${bin}/alias`,
        qs.stringify({
          alias: customerAlias,
        }),
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Authorization: `Bearer ${token}`,
          },
        },
      )
      .then(() => {
        addNotificationAction(Message.aliasApplied[lang])(dispatch);
        dispatch({
          type: CHANGE_ALIAS,
          bin,
          customerAlias,
        });
        onSuccess();
      })
      .catch(onFailure);
  };

export const changeEmailAction =
  ({ otp, email, onSuccess, onFailure }) =>
  (dispatch, getState) => {
    const { lang, token } = getState();
    axios
      .put(
        `${BASE_URL}/users/email`,
        {
          otp,
          email,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      )
      .then(() => {
        addNotificationAction(Message.emailChanged[lang])(dispatch);
        dispatch({
          type: CHANGE_EMAIL,
          email,
        });
        onSuccess();
      })
      .catch((error) => {
        const status = error && error.response && error.response.status;
        const code =
          error &&
          error.response &&
          error.response.data &&
          error.response.data.error &&
          error.response.data.error.code;
        const message =
          (error &&
            error.response &&
            error.response.data &&
            error.response.data.error &&
            error.response.data.error.message) ||
          (error &&
            error.response &&
            error.response.data &&
            error.response.data.message) ||
          "server_error";
        onFailure({ status, code, message });
      });
  };

export const sendOtpAction =
  ({ email, onSuccess, onFailure }) =>
  (dispatch, getState) => {
    const { lang, token } = getState();
    axios
      .post(
        `${BASE_URL}/otp/email`,
        { email },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      )
      .then(() => {
        addNotificationAction(Message.otpSent[lang])(dispatch);
        onSuccess();
      })
      .catch((error) => {
        const status = error && error.response && error.response.status;
        const code =
          error &&
          error.response &&
          error.response.data &&
          error.response.data.error &&
          error.response.data.error.code;
        const message =
          (error &&
            error.response &&
            error.response.data &&
            error.response.data.error &&
            error.response.data.error.message) ||
          (error &&
            error.response &&
            error.response.data &&
            error.response.data.message) ||
          "server_error";
        onFailure({ status, code, message });
      });
  };

export const changePasswordAction =
  ({ password, value, onSuccess, onFailure }) =>
  (dispatch, getState) => {
    const { token } = getState();

    axios
      .put(
        `${BASE_URL}/users/password`,
        {
          oldPassword: password,
          newPassword: value,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      )
      .then(() => {
        onSuccess && onSuccess();
      })
      .catch((error) => {
        const status = error?.response?.status;
        const message =
          error?.response?.data?.message ||
          error?.response?.data?.error?.message ||
          "server_error";

        onFailure && onFailure({ status, message });
      });
  };
